import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const targetAudience = ['Más energía estable sin extremos', 'Menos antojos y más calma al comer', 'Dormir mejor con hábitos simples', "Un plan repetible cuando necesite 'reiniciar'"];
export function ForWhoSection() {
  return <section className="py-20 px-6 md:px-12 bg-white w-full flex justify-center" data-id="element-70">
      <div className="max-w-4xl w-full flex flex-col md:flex-row gap-12 items-center" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="w-full md:w-1/3" data-id="element-72">
          <h2 className="text-3xl md:text-4xl font-playfair text-bark-900 mb-4" data-id="element-73">
            ¿Para quién es?
          </h2>
          <p className="text-lg text-bark-700 font-lato" data-id="element-74">
            Este plan está diseñado para usted si busca:
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="w-full md:w-2/3 bg-sage-50 rounded-2xl p-8 border border-sage-100" data-id="element-75">
          <ul className="space-y-5" data-id="element-76">
            {targetAudience.map((item, index) => <li key={index} className="flex items-center" data-id="element-77">
                <CheckCircle2Icon className="w-6 h-6 text-gold-500 mr-4 flex-shrink-0" data-id="element-78" />
                <span className="text-lg font-lato text-bark-800" data-id="element-79">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}